import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser';
import { isEmptyString } from '@/utils/string';

// https://fly.customer.io/workspaces/56354/pipelines/sources/14282
const sourceApiKey = '74229fee97672a2b4332';
// Workspace: People.Campaigns (138234)
const workspaceSiteId = '5b613177d192212670dc';

const dispatchInAppEvent = (event: CustomEvent) => {
  window.dispatchEvent(new CustomEvent(event.type, { detail: event.detail }));
};

/**
 * Outside production the app loads no instance unless the build names a stack's own JavaScript source,
 * so a stack can exercise in-app messages and web push alerts against its own workspace. Production
 * never reads these variables.
 */
function loadStackAnalytics() {
  const writeKey = import.meta.env.VITE_CIO_SDK_WRITE_KEY;
  const cdnURL = import.meta.env.VITE_CIO_SDK_CDN_URL;
  const apiHost = import.meta.env.VITE_CIO_SDK_API_HOST;
  const siteId = import.meta.env.VITE_CIO_IN_APP_SITE_ID;
  if (isEmptyString(writeKey)) {
    return undefined;
  }
  const inApp = isEmptyString(siteId) ? false : { siteId, colorScheme: 'auto', events: dispatchInAppEvent };
  return AnalyticsBrowser.load(
    { writeKey, cdnURL: isEmptyString(cdnURL) ? undefined : cdnURL },
    {
      integrations: {
        'Customer.io Data Pipelines': isEmptyString(apiHost) ? {} : { apiHost },
        // @ts-expect-error - `integrations.events` is not properly typed,
        'Customer.io In-App Plugin': inApp,
      },
    },
  );
}

export const analytics =
  __CIO_ENV__ === 'production'
    ? AnalyticsBrowser.load(
        { writeKey: sourceApiKey },
        {
          integrations: {
            'Customer.io In-App Plugin': {
              siteId: workspaceSiteId,
              colorScheme: 'auto',
              // @ts-expect-error - `integrations.events` is not properly typed,
              events: (event: CustomEvent) => {
                window.dispatchEvent(
                  new CustomEvent(event.type, {
                    detail: event.detail,
                  }),
                );
              },
            },
          },
        },
      )
    : loadStackAnalytics();
